// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueGtm from 'vue-gtm';
import VueLazyload from 'vue-lazyload';
import VueI18n from 'vue-i18n';
import { Message } from 'element-ui';
import * as moment from 'moment';
import VueMoment from 'vue-moment';
import { sync } from 'vuex-router-sync';
import Cookies from 'js-cookie';
import App from '@/App.vue';
import store from '@/store';
import router from '@/router';
import translation from '@/i18n';
import VBodyScrollLock from 'v-body-scroll-lock';
import resolveLocale from '@/helpers/locale';
// eslint-disable-next-line no-unused-vars
import vi from 'moment/locale/vi';
// eslint-disable-next-line no-unused-vars
import th from 'moment/locale/th';
import 'moment/locale/en-au';
import { zhTW } from './helpers/moment-locale';

moment.locale('zh-Hant-my-settings', zhTW);

moment.defineLocale('zh-Hant', {
  parentLocale: 'zh-TW',
});

sync(store, router);

const isDev = process.env.NODE_ENV === 'development';

Vue.config.productionTip = isDev;

Vue.prototype.$message = Message;
Vue.use(VueMoment, {
  moment,
});

Vue.use(VueGtm, {
  id: 'GTM-T5SJNVK',
  debug: isDev,
  vueRouter: router,
});

Vue.use(VueLazyload);

Vue.use(VueI18n);
let locale = 'zh-Hant';

const cookieLang = Cookies.get('lang');
if (typeof cookieLang === 'string') {
  locale = resolveLocale(cookieLang) || 'zh-Hant';
} else {
  const browserLang = window.navigator.language || window.navigator.userLanguage;
  locale = resolveLocale(browserLang) || 'zh-Hant';
}

if (locale === 'en') {
  const isMonthMiddle = Number(new Date(2024, 0, 2).toLocaleDateString().split('/')[1]) === 1;
  const isDateLeading = Number(new Date(2024, 0, 2).toLocaleDateString().split('/')[0]) === 2;

  if (isDateLeading && isMonthMiddle) {
    moment.updateLocale('en', {
    // eslint-disable-next-line no-underscore-dangle
      longDateFormat: moment.localeData('en-au')._longDateFormat,
    });
  }
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'zh-Hant',
  messages: translation,
});

Vue.filter('properNumber', (value) => {
  if (value) {
    return value.toLocaleString();
  }
  return value;
});

Vue.use(VBodyScrollLock);

new Vue({
  router,
  i18n,
  store,
  created() {
    document.documentElement.lang = this.$i18n.locale;
  },
  watch: {
    '$i18n.locale': function handleLocaleChange(newLocale) {
      document.documentElement.lang = newLocale;
    },
  },
  render: h => h(App),
}).$mount('#app');
